module.exports = __webpack_public_path__ + "42c71aca59852e310873c4539c85335f.woff2";


//////////////////
// WEBPACK FOOTER
// ./fonts/korolev_medium_italic-webfont.woff2
// module id = Osa4
// module chunks = 0